import {
  ApplicationNestedPath,
  ModelNestedPath,
  RouterPath,
  buildAppLink,
  buildModelDetailsLink
} from '@/router/paths'
import { NotificationContext, NotificationType } from '@/types/notifications'

export const getNotificationLink = (
  notificationType: NotificationType,
  notificationContext?: NotificationContext
): string => {
  if (
    notificationType === NotificationType.MODEL_TRAINING &&
    notificationContext &&
    'appId' in notificationContext
  ) {
    const { appId } = notificationContext
    return buildAppLink(appId, ApplicationNestedPath.models)
  }

  if (
    notificationType === NotificationType.FILE_ACTION &&
    notificationContext &&
    'appId' in notificationContext &&
    'modelId' in notificationContext
  ) {
    const { appId, modelId } = notificationContext
    return buildModelDetailsLink(appId, modelId, ModelNestedPath.labelData)
  }

  if (
    [
      NotificationType.MODEL_TRAININGS_PER_MONTH_EXCEEDED,
      NotificationType.MODEL_TEST_DATA_PER_MONTH_EXCEEDED,
      NotificationType.DATASET_STORAGE_LIMIT_EXCEEDED,
      NotificationType.EVENT_STORAGE_LIMIT_EXCEEDED
    ].includes(notificationType)
  ) {
    return RouterPath.subscription
  }

  return '/'
}
